import { translateSportType, Workout } from "./planTypes"

interface RouteHeaderTitlesProps {
	settings: string;
	profile: string;
	'my-progress': string;
	advices: string;
}

const routesHeaderTitles: RouteHeaderTitlesProps = {
	settings: 'Paramètres',
  profile: 'Profil',
	'my-progress': 'Progression',
	advices: 'Conseils'
}



export const HeaderContent = ({ workout }: { workout: Workout} ) => {
	return (
			<>
					{[
							translateSportType(workout.sportType),
							workout.name
					].filter(Boolean).join(' | ')}
			</>
	)
};


export const HeaderTitle = (locationPath: string, userName: string) => {
	const cleanPathname = locationPath.replace('/', '');

	if (cleanPathname === 'dashboard') {
		return `Bienvenue ${ userName } 👋`;
	}

	if (cleanPathname === 'workout') {
		return 'Ma séance';
	}

	if (cleanPathname in routesHeaderTitles) {
		return routesHeaderTitles[cleanPathname as keyof RouteHeaderTitlesProps];
	}

	return ''; // or some default value
};
